import Button from "shared/components/button/Button";
import { SPACES_ROUTE } from 'app/navigation/routes/space-routes';
import { useCallback } from 'react';
import { useNavigationContext } from 'shared/providers/NavigationProvider';
import { useTranslation } from 'react-i18next';

const spaceId = "b7ab7cfe1cb6b7ef7b272e5700d15b70ec425da8c889e5b8a22920adc656d9f7";

const PopularSpace = ({ height = '60vh' }) => {

    const { t } = useTranslation();
    const { navigateToRouteWithState } = useNavigationContext();

    const handleNavigateToSpaceDetailsPage = useCallback(() => navigateToRouteWithState({
        path: `${SPACES_ROUTE}/${spaceId}`,
        state: spaceId
    }),
        [navigateToRouteWithState]
    );

    return (
    <div
        className="w-full flex justify-center items-end relative rounded-xl overflow-hidden"
        style={{
        backgroundImage: "url('https://res.cloudinary.com/dorkbt39x/image/upload/v1765321863/meets-N-works/TX-REAL/2_MG_9911_TX_REAL_garden_avenue_tower_tueess.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height
    }}>
        <div className="absolute inset-0 bg-black/40"></div>
        <div className="absolute bottom-6 left-6 text-white space-y-2">
            <span className=" text-xs font-semibold ">
                {t('website.popularSpaces.creativeSpace.badge')}
            </span>

            <h3 className="text-2xl font-bold tracking-tight drop-shadow-lg">
                {t('website.popularSpaces.creativeSpace.title')}
            </h3>

            <p className="text-sm text-gray-200 max-w-xs leading-relaxed drop-shadow-md pb-4">
                {t('website.popularSpaces.creativeSpace.description')}
            </p>

            <Button
                onClick={handleNavigateToSpaceDetailsPage}
                className="mt-20  px-4 py-2 text-xs font-semibold bg-white/20 hover:bg-lime-700 backdrop-blur-sm rounded-md"
            >
                {t('website.popularSpaces.viewDetails')}
            </Button>
        </div>
    </div>
    );
};

export default PopularSpace;
